import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { Trans, useTranslation } from "react-i18next";

type Props = {
  open: boolean;
  onClose: () => void;
  productName: string;
  onConfirm: () => Promise<unknown>;
  isPending: boolean;
};

export const ProductDeleteModal = ({ open, onClose, productName, onConfirm, isPending }: Props) => {
  const { t } = useTranslation(["boCatalog", "common"]);

  const handleDelete = async () => {
    await onConfirm();
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent className="max-w-[400px]">
        <DialogHeader>
          <DialogTitle>{t("productDeleteModal.title")}</DialogTitle>
        </DialogHeader>
        <div className="mt-4">
          <p className="text-sm text-gray-600">
            <Trans
              t={t}
              i18nKey="productDeleteModal.description"
              values={{ productName }}
              components={{ bold: <span className="font-semibold" /> }}
            />
          </p>
        </div>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={onClose} disabled={isPending} className="flex-1">
            {t("common:actions.cancel")}
          </Button>
          <Button
            variant="destructive"
            onClick={handleDelete}
            disabled={isPending}
            className="flex-1"
          >
            {isPending ? <Loader2 className="animate-spin" /> : t("productDeleteModal.submit")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
